import SectionMixin from '@/mixins/sectionMixin'
import TextWysiwyg from '@/components/global/text-wysiwyg'

export default {
    name: 'pro-full-list-block',
    mixins: [SectionMixin],
    components: {
        'text-wysiwyg': TextWysiwyg,
    },
    props: {
        imgUrl: String,
        title: String,
        description: String,
    },
    data: () => {
        return {
            isIntersecting: false,
            visible: false,
        }
    },
    mounted() {

    },
    beforeDestroy() {

    },
    methods: {
        show() {
            if (this.visible) {
                return
            }
            this.visible = true
        },
        imageFormat(rawFormat){
            switch (true) {
                case (rawFormat === '.png'):
                    return 1
                case (rawFormat === '.jpg'):
                    return 1
                case (rawFormat === '.jpeg'):
                    return 1
                case (rawFormat === '.svg'):
                    return 1
                case (rawFormat === '.gif'):
                    return 1
                default:
                    break;
            }
        },
    }
}